document.addEventListener('click', (event) => {
  if (!event.target.closest('[name="checkout"]')) return;
  if (document.querySelector('[data-vf-shipping-blocked]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector('[data-vf-shipping-blocked]').scrollIntoView({ block: 'center' });
  }
}, true);

document.addEventListener('submit', (event) => {
  if (!event.target.matches('#cart, #CartDrawer-Form')) return;
  if (document.querySelector('[data-vf-shipping-blocked]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector('[data-vf-shipping-blocked]').scrollIntoView({ block: 'center' });
  }
}, true);

(() => {
  const refreshReadyCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    if (window.location.pathname.replace(/\/$/, '') !== root + 'cart') return;
    if (!document.querySelector('[data-vf-shipping-blocked]')) return;
    const storageKey = 'vf-cart-weight-refresh';
    let previous;
    try {
      previous = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch {
      return;
    }
    for (let attempt = 0; attempt < 6; attempt += 1) {
      if (!document.querySelector('[data-vf-shipping-blocked]')) return;
      try {
        const response = await fetch(root + 'cart.js', {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: AbortSignal.timeout(4000),
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) return;
        const cuts = cart.items.filter((item) => item.properties?.['Requested cut length']);
        const ready = cuts.length > 0 && cuts.every((item) => {
          const expected = Number(item.properties['_Estimated material weight grams']);
          const native = Number(item.grams);
          return Number.isFinite(expected) && Number.isFinite(native)
            && expected > 0 && native > 0 && Math.abs(expected - native) <= 5;
        });
        if (ready) {
          const signature = cuts.map((item) => [
            item.key, item.quantity, item.properties['_Estimated material weight grams'],
          ].join(':')).join('|');
          if (previous?.signature === signature && Date.now() - previous.at < 30000) return;
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({ signature, at: Date.now() }));
          } catch {
            return;
          }
          window.location.reload();
          return;
        }
      } catch {}
      if (attempt < 5) await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshReadyCart, { once: true });
  } else {
    refreshReadyCart();
  }
})();
